import _ from 'lodash';

import { RenderRange } from 'utils/priceUtils';
import { consumer } from '@tock/coretypes';
import BaseComponent from '@tock/shared/components/BaseComponent';

interface Props {
  price: consumer.OfferedPriceSummary;
}

export default class AdditionalCosts extends BaseComponent<Props> {
  static feePrice(prices: consumer.OfferedPriceSummary) {
    if (!prices.requiredFees) {
      return null;
    }

    const { name } = prices.requiredFees;
    return <RenderRange text={` ${name || 'Fees'}`} price={prices.requiredFees} />;
  }

  static prices(prices: consumer.OfferedPriceSummary) {
    return _.filter([AdditionalCosts.feePrice(prices)]);
  }

  static hasPriceRanges(prices: consumer.OfferedPriceSummary) {
    return AdditionalCosts.prices(prices).length > 0;
  }

  static hasRequiredFees(requiredFees: consumer.PriceRange): boolean {
    return !_.isNil(requiredFees);
  }

  render() {
    const prices = AdditionalCosts.prices(this.props.price);
    if (prices.length === 0) {
      return null;
    }
    return <span>{prices[0]}</span>;
  }
}
